import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./targetDataTable.html";
const columns = [{
  label: 'Name',
  fieldName: 'name',
  hideDefaultActions: true,
  type: 'queuedName',
  typeAttributes: {
    name: {
      fieldName: 'name'
    },
    type: {
      fieldName: 'componentName'
    },
    developerName: {
      fieldName: 'developerName'
    },
    modifiedBy: {
      fieldName: 'modifiedBy'
    },
    modifiedOn: {
      fieldName: 'modifiedOn'
    }
  }
}, {
  label: 'Validation',
  fieldName: 'message',
  hideDefaultActions: true,
  type: 'validationStatusDisplay',
  typeAttributes: {
    message: {
      fieldName: 'message'
    },
    validationTooltipMessages: {
      fieldName: 'validationTooltipMessages'
    },
    validationType: {
      fieldName: 'validationType'
    },
    isError: {
      fieldName: 'isError'
    }
  }
}, {
  type: 'button',
  initialWidth: 50,
  typeAttributes: {
    iconName: 'utility:close',
    variant: 'base'
  },
  cellAttributes: {
    alignment: 'right'
  }
}];
class TargetDataTable extends LightningElement {
  constructor(...args) {
    super(...args);
    this.items = void 0;
    this.gridLoadingState = false;
    this.columns = columns;
    this.deleteRow = evt => {
      const {
        detail: {
          row: {
            id
          }
        }
      } = evt;
      const removeTargetRecord = new CustomEvent('removetargetrecord', {
        bubbles: true,
        composed: true,
        detail: id
      });
      this.dispatchEvent(removeTargetRecord);
      let updatedList = JSON.parse(JSON.stringify(this.items));
      updatedList = updatedList.filter(item => item.id !== id);
      const updateQueuedCount = new CustomEvent('updatequeuedcount', {
        bubbles: true,
        composed: true,
        detail: updatedList
      });
      this.dispatchEvent(updateQueuedCount);
    };
  }
}
_registerDecorators(TargetDataTable, {
  publicProps: {
    items: {
      config: 0
    }
  },
  fields: ["gridLoadingState", "columns", "deleteRow"]
});
export default _registerComponent(TargetDataTable, {
  tmpl: _tmpl
});